import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'cosmos-corrosion-insights-card',
  imports: [
    TranslatePipe, DecimalPipe, DatePipe,
    DividerModule, CardModule,
  ],
  templateUrl: './corrosion-insights-card.component.html',
  styleUrls: ['./corrosion-insights-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CorrosionInsightsCardComponent {
  readonly corrosionData = input<any>(null);

  readonly lastDataPoint = computed(() => {
    const data = this.corrosionData();
    if (!data?.time?.length) return null;
    const i = data.time.length - 1;
    return {
      temperature: data.temperature[i],
      humidity: data.humidity[i],
      potential: data.potential[i],
      rp: data.rp[i],
      rohm: data.rohm[i],
      last_ice: data.last_ice[i],
      quality: data.quality[i],
    };
  });

  readonly lastDataTime = computed(() => {
    const data = this.corrosionData();
    if (!data?.time?.length) return null;
    return data.time[data.time.length - 1];
  });
}
